import React from 'react';

import classNames from 'classnames';
import QRCode from 'qrcode.react';
import urlJoin from 'url-join';

import {PublicCompanyLogo} from 'components/Publics';
import {VIEWPORT_WIDTHS, SIZES} from 'configs';
import {useViewport} from 'contexts/ViewportContext';

import styles from './styles.module.scss';

const PublicHero = (props) => {
  const {children, companyType, isLoading, logoFiles, noLogo, title, subtitle} =
    props;
  const qrPath = urlJoin(window.location.origin, window.location.pathname);

  const {size} = useViewport();
  const isDesktop = VIEWPORT_WIDTHS[size] > VIEWPORT_WIDTHS[SIZES.lg];

  return (
    <section className={styles['hero']}>
      <div className={styles['hero__title-section']}>
        {!noLogo && (
          <PublicCompanyLogo
            companyType={companyType}
            file={logoFiles}
            size={'lg'}
            className={isDesktop ? 'mb-0' : 'mb-3'}
          />
        )}
        {children ? (
          children
        ) : !isLoading ? (
          <div className={classNames(isDesktop && !noLogo && 'ml-4')}>
            <h1 className={styles['hero__title']}>{title}</h1>
            <p className={styles['hero__subtitle']}>{subtitle}</p>
          </div>
        ) : (
          <div
            className={classNames(
              styles['loading'],
              isDesktop && !noLogo && 'ml-4'
            )}
          >
            <span className={styles['loading--main']} />
            <span className={styles['loading--sub']} />
          </div>
        )}
      </div>

      {isDesktop && !isLoading && (
        <div className={styles['qr-code']}>
          <QRCode value={qrPath} size={98} renderAs="svg" />
          <p className={styles['qr-code__text']}>Scan QR</p>
        </div>
      )}
    </section>
  );
};

export default PublicHero;
